import i18next from 'i18next';
import { ActionTypes } from 'infrastructure/enums/action-types';
import { ModuleType } from 'infrastructure/enums';

export interface IActionTypesItem {
  id: ActionTypes | null | 'All';
  name: string;
  modules: ModuleType[];
}

export const actionTypesDataSource = (
  withNone = true,
  showAll = false,
  excludeTypes: ActionTypes[] = [],
): IActionTypesItem[] => {
  let dataSource: IActionTypesItem[] = [
    {
      id: ActionTypes.Manual,
      name: i18next.t('actionTypes.manual'),
      modules: [ModuleType.RPM, ModuleType.CCM],
    },
    {
      id: ActionTypes.MdReview,
      name: i18next.t('actionTypes.md-review'),
      modules: [ModuleType.RPM, ModuleType.CCM],
    },
    {
      id: ActionTypes.PatientCall,
      name: i18next.t('actionTypes.patient-call'),
      modules: [ModuleType.RPM, ModuleType.CCM],
    },
    {
      id: ActionTypes.PatientMessage,
      name: i18next.t('actionTypes.patient-message'),
      modules: [ModuleType.RPM, ModuleType.CCM],
    },
    {
      id: ActionTypes.PatientMessageResponse,
      name: i18next.t('actionTypes.patient-message-response'),
      modules: [ModuleType.RPM, ModuleType.CCM],
    },
    {
      id: ActionTypes.PatientICD,
      name: i18next.t('actionTypes.patient-icd'),
      modules: [ModuleType.RPM, ModuleType.CCM],
    },
    {
      id: ActionTypes.PatientICDUpdate,
      name: i18next.t('actionTypes.patient-icd-update'),
      modules: [ModuleType.RPM, ModuleType.CCM],
    },
    {
      id: ActionTypes.PatientICDDelete,
      name: i18next.t('actionTypes.patient-icd-delete'),
      modules: [ModuleType.RPM, ModuleType.CCM],
    },
    {
      id: ActionTypes.PatientMedications,
      name: i18next.t('actionTypes.patient-medications'),
      modules: [ModuleType.RPM, ModuleType.CCM],
    },
    {
      id: ActionTypes.PatientMedicationsUpdate,
      name: i18next.t('actionTypes.patient-medications-update'),
      modules: [ModuleType.RPM, ModuleType.CCM],
    },
    {
      id: ActionTypes.PatientMedicationsDelete,
      name: i18next.t('actionTypes.patient-medications-delete'),
      modules: [ModuleType.RPM, ModuleType.CCM],
    },
    {
      id: ActionTypes.PatientPastMedicalHistory,
      name: i18next.t('actionTypes.patient-past-medical-history'),
      modules: [ModuleType.RPM, ModuleType.CCM],
    },
    {
      id: ActionTypes.PatientPastMedicalHistoryUpdate,
      name: i18next.t('actionTypes.patient-past-medical-history-update'),
      modules: [ModuleType.RPM, ModuleType.CCM],
    },
    {
      id: ActionTypes.PatientPastMedicalHistoryDelete,
      name: i18next.t('actionTypes.patient-past-medical-history-delete'),
      modules: [ModuleType.RPM, ModuleType.CCM],
    },
    // RPM
    {
      id: ActionTypes.PatientComment,
      name: i18next.t('actionTypes.general-comments'),
      modules: [ModuleType.RPM, ModuleType.CCM], // ccm for showing in the dropdown when selected CCM module
    },
    {
      id: ActionTypes.OutboundSmsWithTimer,
      name: i18next.t('actionTypes.outbound-sms-with-timer'),
      modules: [ModuleType.RPM], // ??
    },
    {
      id: ActionTypes.OutboundScheduledSms,
      name: i18next.t('actionTypes.outbound-scheduled-sms'),
      modules: [ModuleType.RPM, ModuleType.CCM],
    },
    {
      id: ActionTypes.ReadingReview,
      name: i18next.t('actionTypes.reading-review'),
      modules: [ModuleType.RPM],
    },
    {
      id: ActionTypes.ReadingComment,
      name: i18next.t('actionTypes.reading-comment'),
      modules: [ModuleType.RPM],
    },
    {
      id: ActionTypes.ReadingCall,
      name: i18next.t('actionTypes.reading-call'),
      modules: [ModuleType.RPM],
    },
    {
      id: ActionTypes.ClinicalNotes,
      name: i18next.t('actionTypes.clinical-notes'),
      modules: [ModuleType.RPM, ModuleType.CCM], // ccm for showing in the dropdown when selected CCM module
    },
    {
      id: ActionTypes.BulkReadingReview,
      name: i18next.t('actionTypes.bulk-reading-review'),
      modules: [ModuleType.RPM],
    },
    {
      id: ActionTypes.BulkReadingCommentWithTimer,
      name: i18next.t('actionTypes.bulk-reading-comment-with-timer'),
      modules: [ModuleType.RPM],
    },
    {
      id: ActionTypes.BulkReadingComment,
      name: i18next.t('actionTypes.bulk-reading-comment'),
      modules: [ModuleType.RPM],
    },
    // CCM
    {
      id: ActionTypes.CCMPatientNotes,
      name: i18next.t('actionTypes.clinical-notes'),
      modules: [ModuleType.CCM],
    },
    {
      id: ActionTypes.CCMPatientCallNotes,
      name: i18next.t('actionTypes.general-comments'),
      modules: [ModuleType.CCM],
    },
    {
      id: ActionTypes.PatientGoals,
      name: i18next.t('actionTypes.patient-goals'),
      modules: [ModuleType.CCM],
    },
    {
      id: ActionTypes.PatientGoalsUpdate,
      name: i18next.t('actionTypes.patient-goals-update'),
      modules: [ModuleType.CCM],
    },
    {
      id: ActionTypes.PatientAllergyLog,
      name: i18next.t('actionTypes.patient-allergy-log'),
      modules: [ModuleType.CCM],
    },
    {
      id: ActionTypes.PatientAllergyLogUpdate,
      name: i18next.t('actionTypes.patient-allergy-log-update'),
      modules: [ModuleType.CCM],
    },
  ];

  if (excludeTypes?.length) {
    dataSource = dataSource.filter((item) =>
      item.id === 'All' || item.id === null
        ? true
        : !excludeTypes.includes(item.id),
    );
  }

  if (withNone) {
    dataSource.unshift({
      id: showAll ? ActionTypes.All : null,
      name: i18next.t('actionTypes.all'),
      modules: [ModuleType.RPM, ModuleType.CCM],
    });
  }

  return dataSource;
};
